import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import styled from "@emotion/styled";
import { Box, Button, styled as muiStyled } from "@mui/material";
import { ContactRequestDialog } from "components/dialog/ContactRequestDialog";
import type React from "react";
import { useState } from "react";
import AvatarUser from "../../assets/imgs/avatarContactPart.png";

const BottomContentButton = muiStyled(Button)(({ theme, variant }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "240px",
  minWidth: 0,
  height: "32px",
  padding: "4px 15px",
  whiteSpace: "nowrap",
  border:
    variant === "contained"
      ? `1px solid ${theme.palette.primary.main}`
      : "1px solid",
  fontSize: "clamp(11px, 3vw, 14px)",
  "&:hover": {
    border:
      variant === "contained"
        ? `1px solid ${theme.palette.primary.light}`
        : "1px solid",
  },
}));

const SampleAvatarUser = styled.img({
  maxHeight: "84px",
  maxWidth: "84px",
  width: "auto",
  height: "auto",
  borderRadius: "50%",
  position: "relative",
});

interface ContactRequestButtonProps {
  t: (key: string) => string;
  products?: ColoredMaterial[];
  selectedMaterial?: ColoredMaterial;
}

export const ContactRequestButton = ({
  t,
  products,
  selectedMaterial,
}: ContactRequestButtonProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [modalName, setModalName] = useState<string>("");

  const handleContactExpert = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setModalName("CONTACT_EXPERT");
    setOpen(true);
  };

  const handleRequestSample = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setModalName("REQUEST_SAMPLE");
    setOpen(true);
  };

  const handleRequestQuote = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setModalName("REQUEST_QUOTE");
    setOpen(true);
  };

  return (
    <Box
      id="LDPButtonGroup"
      data-cy={"LDPButtonGroup"}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <SampleAvatarUser src={AvatarUser} />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: "8px",
        }}
      >
        <BottomContentButton
          id="BottomContactExpertBtn"
          data-cy={"BottomContactExpertBtn"}
          onClick={handleContactExpert}
          variant="contained"
        >
          {t("ldp_contact_expert_btn")}
        </BottomContentButton>
        <BottomContentButton
          id="BottomRequestSampleBtn"
          data-cy={"BottomRequestSampleBtn"}
          onClick={handleRequestSample}
          variant="outlined"
        >
          {t("ldp_request_sample_btn")}
        </BottomContentButton>
        <BottomContentButton
          id="BottomRequestQuoteBtn"
          data-cy={"BottomRequestQuoteBtn"}
          onClick={handleRequestQuote}
          variant="outlined"
        >
          {t("ldp_request_quote_btn")}
        </BottomContentButton>
      </Box>
      {open && (
        <ContactRequestDialog
          isOpen={open}
          dialogType={modalName}
          onClose={setOpen}
          products={products}
          selectedMaterial={selectedMaterial}
        />
      )}
    </Box>
  );
};
